import http from '../Http';
import { useContext, useState, useRef } from 'react';
import utils from '../utils';
import { Modal, Button, Input, Form, Upload, Radio, DatePicker } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import config from '../Config';
import { useTranslation } from 'react-i18next';

function DeviceIssueAdd(props) {
    const { t } = useTranslation();
    const setTip = useContext(utils.tipContext);

    const {show, onClose} = props;

    const [form] = Form.useForm();

    const [issueContent, setIssueContent] = useState("");
    const [disabled, setDisabled] = useState(false);

    const handleCancle = () => {
        form.resetFields();
        setDisabled(false);
        onClose(null);
    }

    const handleSubmit = async () => {
        const ps = await form.validateFields().catch(() => {return null});
        
        if (ps === null) {
            return;
        }

        const rawContent = ps.Issue;
        ps.SN = ps.SN || "";
        ps.Content = rawContent ? encodeURIComponent(rawContent) : "";
        ps.Misused = ps.Misused ?? "";
        ps.Asker = ps.Asker || "";
        ps.InstalledTime = ps.InstalledTime ? ps.InstalledTime.format("YYYY-MM-DD") : "";
        ps.Image = [];
        ps.Picture && ps.Picture.fileList && ps.Picture.fileList.forEach(v => {
            ps.Image.push(v.response && v.response.code == 200 ? v.response.data[v.name] : '');
        })
        ps.Image = ps.Image.join(',');
        
        const resp = await http.post("after-sale/device/issue/add", ps).then(async (r)=>{
            return await r.json();
        }).catch((e) => {
            return null;
        });

        try {
            if (resp.code !== 200) {
                setTip({open:true, severity:"error", msg:(resp && resp.msg) ? resp.msg : t("add error")});
                return
            }

            setTip({open: true, severity: 'success', msg: t('add success')});

            ps.Content = rawContent;
            ps.ID = resp.data.ID;
            ps.CreateTime = resp.data.CreateTime;
            ps.ProductName = resp.data.ProductName;
            ps.DistributorName = resp.data.DistributorName;
            onClose(ps);

            form.resetFields();
        } catch (e) {
            setTip({open:true, severity:"error", msg: t("add error")});
        }
    }

    return (<Modal 
        title={t("Add Issue")}
        visible={show}
        cancelText={t("Cancel")}
        okText={t("Submit")}
        mask={true}
        maskClosable={false}
        width={500}
        onCancel={handleCancle}
        onOk={handleSubmit}
        footer={[
            <Button 
                key="Clear" 
                shape="round"
                onClick={() => {
                    form.resetFields();
                }}
                disabled={disabled}
            >{t("Clear")}</Button>,
            <Button key="Cancel" shape="round" onClick={handleCancle} disabled={disabled}>{t("Cancel")}</Button>,
            <Button key="Submit" shape="round" type="primary" onClick={handleSubmit} disabled={disabled}>{t("Submit")}</Button>
        ]}
    >
        <Form
            labelAlign="right"
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 25 }}
            form={form}
            initialValues={{
                Enabled: true,
            }}
        >
            <Form.Item 
                name="SN"
                label={t("SN")}
                rules={[{ required: true }]}
            >
                <Input placeholder={t("Device SN")} style={{ borderRadius: '5px' }} />
            </Form.Item>
            <Form.Item 
                name="Issue"
                label={t("Issue")}
                rules={[{ required: true }]}
            >
                <Input.TextArea 
                    rows={4} 
                    maxLength={500} 
                    showCount={true} 
                    value={issueContent} 
                    placeholder={t("Enter your Issue")}
                    onChange={(e) => {setIssueContent(e.target.value)}}
                />
            </Form.Item>
            <Form.Item 
                name="InstalledTime"
                label={t("InstalledTime")}
            >
                <DatePicker placeholder={t('Select Device Installed Time')} style={{width: '100%'}} />
            </Form.Item>
            <Form.Item 
                name="Misused"
                label={t("Misused")}
            >
                <Radio.Group>
                    <Radio value={1}>{t("Yes")}</Radio>
                    <Radio value={0}>{t("No")}</Radio>
                </Radio.Group>
            </Form.Item>
            <Form.Item 
                name="Asker"
                label={t("Asker")}
            >
                <Input placeholder={t("Your Name")} style={{ borderRadius: '5px' }} />
            </Form.Item>
            <Form.Item 
                name="Picture"
                label={t("Image")}
            >
                <Upload 
                    name="Picture"
                    listType="picture"
                    accept=".png,.jpg,jpeg"
                    action={config.apiUrl + "after-sale/picture/upload/do"}
                    headers={{'Token': http.token}}
                    multiple={true}
                    beforeUpload={() => {
                        setDisabled(true);
                    }}
                    onChange={(info) => {
                        if(info && info.file && info.file.status === 'done') {
                            setDisabled(false);
                        }
                    }}
                >
                    <Button icon={<UploadOutlined />}>{t("Choose Images")}</Button>
                </Upload>
            </Form.Item>
        </Form>
    </Modal>);
}

export default DeviceIssueAdd;